import { render, staticRenderFns } from "./OneLineInputs.vue?vue&type=template&id=b23195f6&scoped=true&"
var script = {}
import style0 from "./OneLineInputs.vue?vue&type=style&index=0&id=b23195f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b23195f6",
  null
  
)

export default component.exports